"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueOr = void 0;
/**
 * Returns the supplied value if it is not undefined otherwise it returns the or value.
 *
 * @param value The Value that could be undefined
 * @param or The fallback value
 */
exports.valueOr = (value, or) => {
    if (typeof value !== 'undefined')
        return value;
    return or;
};
//# sourceMappingURL=value-or.js.map